import { ProjectTransitiveDependency } from '@models';

export interface ProjectTransitiveDependencyResult {
  projectTransitiveDependencies: ProjectTransitiveDependency[];
}
